import { useState, useEffect, useRef } from 'react';

const BORDER = '#e0e0e0';
const FONT = "'Raleway', sans-serif";

export default function CustomDropdown({
  options,
  value,
  onChange,
  placeholder = 'Select…',
  triggerStyle = {},
  accentColor = '#0C2D48',
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    function outside(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener('mousedown', outside);
    return () => document.removeEventListener('mousedown', outside);
  }, []);

  function handleKeyDown(e) {
    const idx = options.findIndex(o => o.value === value);
    if (e.key === 'ArrowDown') { e.preventDefault(); if (idx < options.length - 1) onChange(options[idx + 1].value); }
    if (e.key === 'ArrowUp')   { e.preventDefault(); if (idx > 0) onChange(options[idx - 1].value); }
    if (e.key === 'Enter')     { e.preventDefault(); setOpen(v => !v); }
    if (e.key === 'Escape')    { setOpen(false); }
  }

  const selected = options.find(o => o.value === value);

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button
        type="button"
        onClick={() => setOpen(v => !v)}
        onKeyDown={handleKeyDown}
        style={{
          width: '100%', padding: '9px 12px',
          border: `1px solid ${BORDER}`, borderRadius: 8,
          fontSize: 14, boxSizing: 'border-box', outline: 'none',
          background: '#fff', fontFamily: FONT, color: '#111',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          cursor: 'pointer', textAlign: 'left',
          ...triggerStyle,
        }}
      >
        <span style={{ fontWeight: 600 }}>{selected?.label ?? placeholder}</span>
        <svg
          width="12" height="8" viewBox="0 0 12 8" fill="none"
          style={{ flexShrink: 0, transform: open ? 'rotate(180deg)' : 'none', transition: 'transform 0.15s' }}
        >
          <path d="M1 1L6 7L11 1" stroke="#6b7280" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>

      {open && (
        <div style={{
          position: 'absolute', top: 'calc(100% + 4px)', left: 0, right: 0,
          background: '#fff', border: `1px solid ${BORDER}`, borderRadius: 8,
          boxShadow: '0 4px 16px rgba(0,0,0,0.12)', zIndex: 200, overflow: 'hidden',
        }}>
          {options.map((opt, i) => (
            <div
              key={opt.value}
              onClick={() => { onChange(opt.value); setOpen(false); }}
              style={{
                padding: '10px 14px', cursor: 'pointer',
                background: value === opt.value ? `${accentColor}10` : '#fff',
                borderBottom: i < options.length - 1 ? '1px solid #f0f0f0' : 'none',
              }}
              onMouseEnter={e => { if (value !== opt.value) e.currentTarget.style.background = '#f9fafb'; }}
              onMouseLeave={e => { e.currentTarget.style.background = value === opt.value ? `${accentColor}10` : '#fff'; }}
            >
              <div style={{ fontSize: 13, fontWeight: 600, color: value === opt.value ? accentColor : '#222' }}>
                {opt.label}
              </div>
              {opt.hint && (
                <div style={{ fontSize: 11, color: '#888', marginTop: 1 }}>{opt.hint}</div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
